<template>
    <div class="setting-docs-view p-4">
        <div v-html="docs[docKey]"></div>
        <button class="btn btn-lg btn-block btn-light mt-4" @click="$router.go(-1)">ย้อนกลับ</button>
    </div>
</template>

<script>
import docs from '../../../docs'

export default {
    data: () => ({
        docs: {
            tos: docs.tos,
            fee: docs.fee
        }
    }),
    props: ['docKey']
}
</script>

<style lang="scss">
</style>
